import { HtmlOverlay } from './components/overlay/HtmlOverlay'
import { useGameLoop } from './hooks/useGameLoop'

export default function App() {
  useGameLoop()

  return (
    <div className="relative h-full w-full overflow-hidden bg-[#0b1a12]">
      <HtmlOverlay />
    </div>
  )
}
